import React from 'react';
import { Modal, Tabs } from 'antd';
import PerformanceTab from './PerformanceTab';


const { TabPane } = Tabs;

const DoctorPErformance = ({
  visible,
  onClose,
  doctor,

}) => {
    
  return (
    <Modal
      title={'Doctor Performance'}
      open={visible}
      onCancel={onClose}
      width={900}
      footer={null}
      destroyOnClose
    >
      <Tabs activeKey={"1"} >

        <TabPane 
            tab={`Performance `}
            key="1"
          >
            <PerformanceTab specialistId={doctor?.doctorId} />
          </TabPane>
      </Tabs>
    </Modal>
  );
};

export default DoctorPErformance;